@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.error-message-container {
  padding-top: @space-12;
  padding-bottom: 16px;
}

.fulfillment-provider-logo {
  height: 20px;
  width: 20px;
  min-width: 20px;
  margin-right: @space-4;

  > img {
    height: 100%;
    width: 100%;
  }
}

.empty-body-message {
  align-items: center;
  justify-content: center;
  padding: @space-12;
}
